// src/api/settingsApi.js
import apiClient from './axios';

const settingsApi = {
  getSettings: async () => {
    const response = await apiClient.get('/settings/');
    return response.data;
  },

  updateSettings: async (data) => {
    const response = await apiClient.patch('/settings/', data);
    return response.data;
  },
};

export default settingsApi;